import { formaterMontant } from '../lib/format';

export interface SaisieMembre {
  /** Cotise-t-il a l'association sur l'annee affichee (RG-06) ? */
  cotise: boolean;
}

/**
 * Statut associatif dans un formulaire d'adherent.
 *
 * Une seule chose s'y saisit : la COTISATION de l'annee, qui fait le
 * membre actif et se refait chaque annee (RG-06, RG-07 revisee).
 *
 * La liste « Titre » a ete retiree le 2026-08-29 avec la colonne
 * `type_membre` : `fondateur` et `honneur` conferaient le statut sans
 * cotiser (RG-08), mais aucune fiche n'en portait — 350 sur 350 etaient
 * `usager`. Le statut se derive desormais des deux seules conditions qui
 * comptent : etre inscrit, et cotiser.
 */
export function ChampMembre({
  valeur,
  onChanger,
  anneeLibelle,
  montantAdhesion,
  inscrit,
  verrouille,
}: {
  valeur: SaisieMembre;
  onChanger: (valeur: SaisieMembre) => void;
  anneeLibelle: string | null;
  montantAdhesion: number | null;
  /**
   * A-t-il au moins une inscription sur l'annee affichee ? La cotisation
   * se saisit quand meme — elle peut preceder l'inscription — mais le
   * statut ne sera acquis qu'une fois l'eleve inscrit, et le dire ici
   * evite de chercher pourquoi la pastille n'apparait pas.
   */
  inscrit?: boolean;
  /** Annee cloturee : la cotisation ne se pose ni ne se retire plus (RG-27). */
  verrouille?: boolean;
}) {
  return (
    <div className="rounded-md border border-encre-200 p-3">
      <div className="etiquette">Statut associatif</div>

      <label className="mt-1 flex items-start gap-2 text-sm">
        <input
          type="checkbox"
          className="mt-0.5"
          checked={valeur.cotise}
          disabled={verrouille}
          onChange={(evenement) => onChanger({ cotise: evenement.target.checked })}
        />
        <span>
          Membre actif — cotise à l’association
          {montantAdhesion !== null && ` (${formaterMontant(montantAdhesion)}`}
          {anneeLibelle && montantAdhesion !== null && ` sur ${anneeLibelle}`}
          {montantAdhesion !== null && ')'}
        </span>
      </label>

      {valeur.cotise && inscrit === false && (
        <p className="mt-2 text-xs text-amber-700">
          La cotisation sera enregistrée, mais le statut de membre actif demande aussi une
          inscription à une activité sur cette année.
        </p>
      )}

      <p className="mt-2 text-xs text-encre-400">
        La cotisation se renouvelle chaque année. Est membre actif l’adhérent inscrit à au moins
        une activité et à jour de sa cotisation.
      </p>
    </div>
  );
}
